export default __webpack_public_path__ + "static/Hazard_Suit_Boots-5d7828880c7c2dfbf34d8657cc2e33ab.png";